import React from 'react';
import { Checkbox } from '@fluentui/react-components';
import "./checkbox.css"

interface Props {
    checkedDays: boolean[];
    onCheckboxChange: (index: number, day: string) => void;
}

export const Checked: React.FC<Props> = ({ checkedDays, onCheckboxChange }) => {
    const firstDayOfWeek = localStorage.getItem('Firstdayofweek') || 'Monday'; // Default to 'Monday' if nothing is in localStorage
    const shortFirstDayOfWeek = convertToShortForm(firstDayOfWeek); // Convert full day name to short form
    const days = rearrangeWeekDays(shortFirstDayOfWeek); // Rearrange based on the short form of the first day

    return (
        <div>
            {days.map((day) => {
                const originalIndex = WeekDays.indexOf(day); // Map back to the original index in checkedDays
                return (
                    <Checkbox
                        key={day}
                        checked={checkedDays[originalIndex]} // Use the original index
                        onChange={() => onCheckboxChange(originalIndex, day)} // Pass the original index to the change handler
                        label={day}
                        size="large"
                    />
                );
            })}
        </div>
    );
};

// Array of short form week days
const WeekDays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

// Convert full day names to short form
const convertToShortForm = (day: string): string => {
    const dayMap: { [key: string]: string } = {
        Sunday: 'Sun',
        Monday: 'Mon',
        Tuesday: 'Tue',
        Wednesday: 'Wed',
        Thursday: 'Thu',
        Friday: 'Fri',
        Saturday: 'Sat'
    };
    return dayMap[day] || day; // Return the short form or the original if not found
};

// Rearrange the week days based on the first day of the week
const rearrangeWeekDays = (firstDay: string): string[] => {
    const index = WeekDays.indexOf(firstDay);
    if (index === -1) return WeekDays; // Return original array if the first day is not found
    return [...WeekDays.slice(index), ...WeekDays.slice(0, index)];
};

